import { makeStyles } from 'tss-react/mui';
import { formStyles } from '../../../styles/jss/form';
import { link } from '../../../styles/jss/utils';
import { colors, spacing } from '../../../styles/jss/variables';
import { addEditAddressStyles } from '../../../styles/jss/addEditAddress';
const useStyles = makeStyles()((theme) => (Object.assign(Object.assign(Object.assign({}, addEditAddressStyles(theme)), formStyles(theme)), { searchAddressLink: Object.assign(Object.assign(Object.assign(Object.assign({ marginTop: spacing.small }, link(colors.primary.gold4)), { color: colors.primary.gold5 }), theme.typography.small_regular), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.medium_regular) }), countryTitle: {
        marginTop: `${spacing.medium} !important`,
    } })));
export default useStyles;
